import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {FETCH_TRANSACTIONS,CLEAR_SELECTED_TRANSACTIONS,DELETE_TRANSACTION,
    FETCH_FOCUS_AREAS,
    FETCH_ALL_SELLERS_LIST,} from "actions/actionTypes";
import queryString from 'query-string'
import async  from 'async';
import PaginationBox from'shared/PaginationBox';
import RemoveModalDialog from'shared/RemoveModalDialog';
import PartnerTransactionListTable from 'partners/transactions/PartnerTransactionListTable';
import PartnerTransactionSearchBox from 'partners/transactions/PartnerTransactionSearchBox'
import PartnerTransactionActionsBox from 'partners/transactions/PartnerTransactionActionsBox'

 import config from  '../../../config';

class PartnerTransactionPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
          this.state = {
            perPage: config.table.numberPerPage,
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) -1,
            selectAllTransactions:false,
         };
      };

    componentWillMount() {

        var self = this;

        if (_.size(self.props.allSellersList.data) == 0) {
            var methodData = {
                "success_event": FETCH_ALL_SELLERS_LIST,
                "endpoint": "/sellers",
                'not_display_success_message': true
            };
var SellerGroupID = _.get(this.props.userReducer.user,'CustomData.SellerGroupID','')
            if( !_.isUndefined(this.props.location.query.SellerGroupID)  && _.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), [ 'Administrator'])) > 0){
                SellerGroupID =  this.props.location.query.SellerGroupID
            }
            this.props.makeRequest({sortBy:'DisplayName:1',all:true,
              SellerGroupID:SellerGroupID,
                include:['DisplayName','InventoryOwnership']}, methodData).catch(err => {
            });
        }
    }

    toggleAllTransactionsSelection(value) {
         if (value) {
            this.setState({ selectAllTransactions:true});
        }else{
            this.setState({ selectAllTransactions:false});
        }
    }

    onSortChange(field, sortOrder){
         this.setState({sortBy: field + ':' + (sortOrder ==  'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params={}) {
      const self = this;
      if (this.state.pending){
         this.props.displayMessage({
          'messageType': 'warning',
          'messageCode': 'Please wait till search request is completed'
        });
        return Promise.reject(false)
      }
      this.setState({pending:true})
         if (_.isUndefined(params.doNotClearSelectedTransactions) && _.isUndefined(params.page)) { /* do not clear selected transactions when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
        }

        var fieldsToOmit = ['include','sortBy','sortByThird', 'useAnalyticDatabase',
          'sortBySecondary', 'addFields','PickupID', 'CreatedByUserID','lookup', 'all','sortBySecondary'];
        if (_.size(_.get(this.refs.actionsBox, 'state.additionalDataFields', []))) {
            this.refs.actionsBox.fetchAdditionalData({})
        }

         var {queryParams} = this.searchBox.getSearchParams();

        if (params.page == 1) {
          params.page = undefined;
        }

        _.extend(queryParams, params);


        if (!_.isUndefined(params.include)  ) {
            queryParams.include = params.include;
        }

        if (_.get(this.props.userReducer.user,'CustomData.SellerGroupID')) {
            queryParams.SellerGroupID = _.get(this.props.userReducer.user, 'CustomData.SellerGroupID')
            fieldsToOmit.push('SellerGroupID')
        }
           if( !_.isUndefined(this.props.location.query.SellerGroupID)  && _.size(_.intersection(_.get(this.props, 'userReducer.user.Roles', []), [ 'Administrator'])) > 0){
               queryParams.SellerGroupID =  this.props.location.query.SellerGroupID
           }

        if (!_.isUndefined(params.all)  ) {
            queryParams.all = true;
        }

        if (this.state.sortBy) {
                 queryParams.sortBy = this.state.sortBy;
                queryParams.sortBySecondary = '_id:-1';
                /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
         }

        if(queryParams.Types && queryParams.Types.length == 3 && queryParams.Types.every(item=>['Sale', 'Fee', 'Credit'].includes(item)) ) {
          fieldsToOmit.push('Types'); /* if all available Types are selected, do not add them in URL */
        }
        queryParams.lookup = [  'Sellers' ]
         var methodData = {
            "endpoint": "/transactions",
            'not_display_success_message': true
        };
        if (_.isUndefined(params.include)  ) {
            methodData['success_event'] = FETCH_TRANSACTIONS;
        }

        const stringified = queryString.stringify(_.omit(queryParams,fieldsToOmit));
        delete queryParams.ServiceID /* PickupID is used instead of ServiceID*/
        this.context.router.push('/partner/transactions?' + stringified);

        return this.props.makeRequest(queryParams, methodData).then(function(response) {
          self.setState({pending:false})
             return  response
        }).catch(err => {
           self.setState({pending:false})
          return Promise.reject(false)

        });
     }
    getAggregatedData(params) {
        return new Promise((resolve, reject) => {
            var self = this
            var functionsToCall = {};
            _.forEach(params.additionalDataFields, function (field, index) {

                functionsToCall[field.value] = function (done) {
                    var {queryParams} = self.searchBox.getSearchParams();
                   queryParams.groupBy = field.value
                    queryParams.all = true;
                    //   queryParams.lookup = ['CreatedByUserID','SellerID','Pickup', 'Transactions']
                    queryParams.addFields = params.totalDataFields
                    var methodData = {
                        "endpoint": "/transactions",
                        'not_display_success_message': true
                    };
                    delete queryParams.ServiceID
                    return self.props.makeRequest(queryParams, methodData).then(function (res) {
                         done(null, res.data)
                    }).catch(err => {
                         done(err)
                    });
                }
            })
            async.parallel(functionsToCall,
                function (err, results) {
                     if (err) {
                        return reject()
                    }
                     resolve(results)
                })
        })
    }
    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }
    deleteRecord( ) {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            'type': 'delete',
            endpoint: '/transactions/' + encodeURIComponent(this.state.currentRecord._id),
            messageData: {'#1#': 'Transaction'},
            messageCode: 'recordDeleted',
            'success_event': DELETE_TRANSACTION,
            'success_event_data': { 'transactionID': this.state.currentRecord._id},
        };

        this.props.makeRequest({  }, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
         });

    }
    render() {
           return (
            <div >
                 <PartnerTransactionActionsBox
                    ref={'actionsBox'}
                    searchBox={this.searchBox}
                     search={this.search.bind(this)} getAggregatedData={this.getAggregatedData.bind(this)}   {...this.props} ></PartnerTransactionActionsBox>

                <PartnerTransactionSearchBox
                  pending={this.state.pending}
                    ref={(searchBox)=> {
                         if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox
                        }
                    }}

                                       search={this.search.bind(this)}  selectAllTransactions = {this.state.selectAllTransactions} toggleAllTransactionsSelection = {this.toggleAllTransactionsSelection.bind(this)}   {...this.props} ></PartnerTransactionSearchBox>

                {this.props.adminTransactions.fetched &&
                <div>
                    { this.props.adminTransactions.total == 0 ?
                        <div
                            className="messageBox"
                            data-testid='message-box'
                        >{config.clientMessages.noRecordsFoundForCriteria.replace('#1#', 'Transactions')}</div> :
                        <div className="top20">

                                <PartnerTransactionListTable onSortChange={this.onSortChange.bind(this)}
                                                       showRemoveDialog={this.showRemoveDialog.bind(this)}
                                                          total={this.props.adminTransactions.total == 'initial' ? 0 : this.props.adminTransactions.total}
                                                       search={this.search.bind(this)} {...this.props}  ></PartnerTransactionListTable>
                            <PaginationBox
                                currentPage={this.state.currentPage}
                                perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : undefined}
                                ref={'pagination'}
                                total={this.props.adminTransactions.total == 'initial' ? 0 : this.props.adminTransactions.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>
                        </div>}
                </div>
                }
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteRecord() }
                    closeModal={(e) => this.setState({currentItemID: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
     return {
          userReducer: state.userReducer,
        adminTransactions: state.adminTransactions,
         allSellersList :state.allSellersList,
        appData:state.appData,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest,dispatchAction,  displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerTransactionPage);
